import React from 'react';
import {useOutletContext} from 'react-router-dom';
import CompatibleItems from '../components/CompatibleItems';
import type {ItemPageContext} from './ClothingItemDetail';

const ItemOutfitsTab: React.FC = () => {
    const {item, itemId, selectedOwnerId} = useOutletContext<ItemPageContext>();

    if (item.thrownAway) {
        return (
            <p className="text-sm text-gray-500 dark:text-gray-400">
                Вещь выброшена — подборка недоступна.
            </p>
        );
    }

    return <CompatibleItems itemId={itemId} ownerId={selectedOwnerId}/>;
};

export default ItemOutfitsTab;
